// @ts-nocheck
/**
 * @generated
 * @file Greenchoice4Pilaren (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link Greenchoice4Pilaren}
 */
export type Greenchoice4PilarenProps = {
  image1?: string;
  image2?: string;
  image3?: string;
  image4?: string;
  text2?: React.ReactNode;
  text3?: React.ReactNode;
  text4?: React.ReactNode;
  text5?: React.ReactNode;
  title1?: React.ReactNode;
  title2?: React.ReactNode;
  title3?: React.ReactNode;
  title4?: React.ReactNode;
  title5?: React.ReactNode;
};

/**
 * Greenchoice4Pilaren
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function Greenchoice4Pilaren({
  image1 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b9634c211e67b2fd552529_icoon_bomen.svg",
  image2 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b9634ce4c6e75df676de82_icoon_minderverbruik.svg",
  image3 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b9634c5b7aef048a882ad7_icoon_samenwerken.svg",
  image4 = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b9634ca25edad93203dd19_icoon_zon.svg",
  text2 = "Projecten waarmee we werken aan meer ruimte voor verschillende planten en dieren.",
  text3 = "Projecten gericht op het beschermen en herstellen van natuur die CO₂ opneemt en vasthoudt.",
  text4 = "Projecten waarin we samen met lokale gemeenschappen werken aan natuur die ook voor hen belangrijk is.",
  text5 = "Projecten waarmee we de natuur en mensen helpen omgaan met de gevolgen van klimaatverandering.",
  title1 = "De vier pijlers waarop natuurprojecten geselecteerd worden",
  title2 = "Biodiversiteit",
  title3 = (
    <>
      {"CO₂-vastlegging"}
      <br />
    </>
  ),
  title4 = (
    <>
      {"Lokale gemeenschappen"}
      <br />
    </>
  ),
  title5 = "Klimaatadaptatie",
}: Greenchoice4PilarenProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"vertical-flex-greenchoice"} tag={"div"}>
            <Heading className={"h2-greenchoice"} tag={"h2"}>
              {title1}
            </Heading>
            <Paragraph className={"paragraph-greenchoice"}>
              {
                "Onze natuurprojecten dragen bij aan één of meer van onze vier pijlers:"
              }
            </Paragraph>
            <Block className={"div-block-297"} tag={"div"}>
              <Block
                className={"vertical-flex-greenchoice"}
                id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15040b-ee1503fd"}
                tag={"div"}
              >
                <Image
                  alt={""}
                  className={"pijler-image-greenchoice"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image1}
                  width={"auto"}
                />
                <Heading
                  className={"h3-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15040d-ee1503fd"}
                  tag={"h3"}
                >
                  {title2}
                </Heading>
                <Paragraph
                  className={"text-small-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15040f-ee1503fd"}
                >
                  {text2}
                </Paragraph>
              </Block>
              <Block
                className={"vertical-flex-greenchoice"}
                id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150411-ee1503fd"}
                tag={"div"}
              >
                <Image
                  alt={""}
                  className={"pijler-image-greenchoice"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image2}
                  width={"auto"}
                />
                <Heading
                  className={"h3-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150413-ee1503fd"}
                  tag={"h3"}
                >
                  {title3}
                </Heading>
                <Paragraph
                  className={"text-small-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150416-ee1503fd"}
                >
                  {text3}
                </Paragraph>
              </Block>
              <Block
                className={"vertical-flex-greenchoice"}
                id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150418-ee1503fd"}
                tag={"div"}
              >
                <Image
                  alt={""}
                  className={"pijler-image-greenchoice"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image3}
                  width={"auto"}
                />
                <Heading
                  className={"h3-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15041a-ee1503fd"}
                  tag={"h3"}
                >
                  {title4}
                </Heading>
                <Paragraph
                  className={"text-small-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15041d-ee1503fd"}
                >
                  {text4}
                </Paragraph>
              </Block>
              <Block
                className={"vertical-flex-greenchoice"}
                id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee15041f-ee1503fd"}
                tag={"div"}
              >
                <Image
                  alt={""}
                  className={"pijler-image-greenchoice"}
                  height={"auto"}
                  loading={"lazy"}
                  src={image4}
                  width={"auto"}
                />
                <Heading
                  className={"h3-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150421-ee1503fd"}
                  tag={"h3"}
                >
                  {title5}
                </Heading>
                <Paragraph
                  className={"text-small-greenchoice"}
                  id={"w-node-a79c3ed9-20f5-47a2-4d6d-36bfee150423-ee1503fd"}
                >
                  {text5}
                </Paragraph>
              </Block>
            </Block>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
